import { useHistory } from "react-router-dom";
import STHeaderNotification from "../../../assets/styles/organisms/headerNotification.module.scss";
import Avatar from "../../atoms/Avatar";
import { useGetNextPage, useGetPreIconFavico } from "./hooks";
import MessageBoardNickname from "../../atoms/MessageBoardNickname";
import { getLocalTime } from "../../../utils/getLocalTime";

type PreIconProps = {
  type: number;
  avatarUrl?: string;
  className?: string;
};

const APPROVAL_BOARD = "APPROVAL_BOARD";
const APPROVAL_COMMENT = "APPROVAL_COMMENT";
const REJECT_BOARD = "REJECT_BOARD";
const REJECT_COMMENT = "REJECT_COMMENT";
const COMMENT_ON_BOARD = "COMMENT_ON_BOARD";
const REPLY_ON_COMMENT = "REPLY_ON_COMMENT";
const REACT_BOARD = "REACT_BOARD";
const REACT_COMMENT = "REACT_COMMENT";
const PUBLIC_BOARD = "PUBLIC_BOARD";
const PUBLIC_COMMENT = "PUBLIC_COMMENT";
const PRIVATE_BOARD = "PRIVATE_BOARD";
const PRIVATE_COMMENT = "PRIVATE_COMMENT";

const NotificationType = {
  [APPROVAL_BOARD]: 1,
  [APPROVAL_COMMENT]: 2,
  [REJECT_BOARD]: 3,
  [REJECT_COMMENT]: 4,
  [COMMENT_ON_BOARD]: 5,
  [REPLY_ON_COMMENT]: 6,
  [REACT_BOARD]: 7,
  [REACT_COMMENT]: 8,
  [PRIVATE_COMMENT]: 10,
  [PUBLIC_COMMENT]: 11,
  [PRIVATE_BOARD]: 12,
  [PUBLIC_BOARD]: 13,
};

const mappingUsingFavicon = [
  NotificationType.APPROVAL_BOARD,
  NotificationType.APPROVAL_COMMENT,
  NotificationType.REJECT_BOARD,
  NotificationType.REJECT_COMMENT,
  NotificationType.PRIVATE_COMMENT,
  NotificationType.PUBLIC_COMMENT,
  NotificationType.PRIVATE_BOARD,
  NotificationType.PUBLIC_BOARD,
];

const PreIcon = (props: PreIconProps) => {
  const { type, avatarUrl = "", className = "" } = props ?? {};
  const preIconFavico = useGetPreIconFavico();

  if (mappingUsingFavicon.includes(type)) {
    return <Avatar avatarUrl={preIconFavico} className={className} />;
  }

  return <Avatar avatarUrl={avatarUrl} className={className} />;
};

const Notification = (props: any) => {
  const {
    id,
    content,
    type,
    avatar_url,
    nickname = "",
    title,
    isLastIndex = false,
    created_at,
    board_id,
    category_id,
  } = props ?? {};
  const history = useHistory();

  const { lastItemRef } = useGetNextPage();

  if (!type) {
    return null;
  }

  return (
    <div
      ref={isLastIndex ? lastItemRef : null}
      className={`${STHeaderNotification.notification} `}
      key={`notification_item_${id}`}
      onClick={() => {
        if (board_id && category_id) {
          history.push(`/message-board/categories/${category_id}/${board_id}`);
        }
      }}
    >
      <PreIcon
        type={type}
        avatarUrl={avatar_url}
        className={STHeaderNotification.preIcon}
      />
      <div className={STHeaderNotification.body}>
        <p>
          {!mappingUsingFavicon.includes(type) && (
            <MessageBoardNickname
              component="span"
              nickname={nickname}
              className={STHeaderNotification.nickname}
            />
          )}
          {title}
        </p>
        {content && (
          <div className={STHeaderNotification.notificationContent}>
            {content}
          </div>
        )}
        <p className={STHeaderNotification.notificationCreatedAt}>
          {getLocalTime(created_at)}
        </p>
      </div>
    </div>
  );
};

export default Notification;
